import { classificationRules } from '@/lib/map-click-handler/classification-rules'
import type MapFeature from '@/lib/map-feature'
import type { State, ClassifiedFeatures } from '@/lib/map-click-handler/types'
import { Vertical } from '@/types/verticals'

/**
 * *(AI-generated)*
 * Classifies an array of map features into typed buckets (parcels, markups, trail cams, etc.) based on the current app.
 */
export function classifyFeatures(queryFeatures: MapFeature[]) {
  const state: State = {
    stateClicked: '',
    multiQueryOverride: false,
  }

  const classifiedFeatures: ClassifiedFeatures = {
    // Shared
    offlineMapClicked: [],
    markupsClicked: [],
    privateParcelsClicked: [],
    publicParcelsClicked: [],
    searchResultsClicked: [],

    // Fish
    catchPolygonClicked: [],
    waterbodyClicked: [],
    fishingAreaClicked: [],
    waterAccessClicked: [],
    waterbodyBadgesClicked: [],
    eventClicked: [],
  }

  const rules = [
    ...classificationRules[Vertical.Fish],
    ...classificationRules['shared'],
  ]

  // Classify all features in the stack
  queryFeatures.reduce((acc, feature) => {
    rules.forEach(({ test, target }) => {
      // If test returns `true`, push to that classification bucket
      if (test({ feature, state }) && target) {
        acc[target].push(feature)
      }
    })
    return acc
  }, classifiedFeatures)

  return { classifiedFeatures, state }
}
